import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landingPage';
import E2 from './pages/E2';
import BSOE from './pages/BSOE';
import About from './pages/aboutUs';
import Help from './pages/Help';
import Resources from './pages/Resources';
import Register from './pages/registrationPage'
import Login from './pages/loginPage'
import Profile from './pages/profilePage'

function App() {

  return (
    <div className='container'>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/e2" element={<E2 />} />
          <Route path="/bsoe" element={<BSOE />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
